import React from 'react';
import './less/option.less';
import { Card, Button, Popover, Radio, Tag } from 'antd';



const Option = () => {

    const mapOption_0 = new Map([
        [0, 'انصراف'],
        [1, '1 ماهه'],
        [2, '3 ماهه'],
        [3, '6 ماهه'],
        [4, '9 ماهه'],
        [5, 'یک ساله']
    ])
    const [option_0, setOption_0] = React.useState({ visible: false, value: 0 });
    const handleOption_0 = (option) => {
        let o = { visible: !option.visible, value: option.value }
        setOption_0(o)
    }
    const handleSelect_0 = (val) => {
        let o = { visible: false, value: val }
        setOption_0(o)
    }
    const unsetOption_0 = () => {
        let o = { visible: false, value: 0 }
        setOption_0(o)
    }



    const mapOption_1 = new Map([
        [0, 'انصراف'],
        [1, '1 ماهه'],
        [2, '3 ماهه'],
        [3, '6 ماهه'],
        [4, '9 ماهه'],
        [5, 'یک ساله']
    ])
    const [option_1, setOption_1] = React.useState({ visible: false, value: 0 });
    const handleOption_1 = (option) => {
        let o = { visible: !option.visible, value: option.value }
        setOption_1(o)
    }
    const handleSelect_1 = (val) => {
        let o = { visible: false, value: val }
        setOption_1(o)
    }
    const unsetOption_1 = () => {
        let o = { visible: false, value: 0 }
        setOption_1(o)
    }




    const content_0 = (
        <Radio.Group onChange={(event) => handleSelect_0(event.target.value)} value={option_0.value}>
            <Radio value={0}>انصاف</Radio>
            <Radio value={1}>1 ماهه</Radio>
            <Radio value={2}>3 ماهه</Radio>
            <Radio value={3}>6 ماهه</Radio>
            <Radio value={4}>9 ماهه</Radio>
            <Radio value={5}>یک ساله</Radio>
        </Radio.Group>
    );

    const content_1 = (
        <Radio.Group onChange={(event) => handleSelect_1(event.target.value)} value={option_1.value}>
            <Radio value={0}>انصاف</Radio>
            <Radio value={1}>1 ماهه</Radio>
            <Radio value={2}>3 ماهه</Radio>
            <Radio value={3}>6 ماهه</Radio>
            <Radio value={4}>9 ماهه</Radio>
            <Radio value={5}>یک ساله</Radio>
        </Radio.Group>
    );

    return (
        <Card title="انتخاب بسته ها (اختیاری)">

            <div className="">
                <div className="ant-row ant-row-rtl">
                    <p>توضیحات</p>
                </div>

                <div className="ant-row ant-row-rtl">

                    <div className="ant-col ant-col-xs-24 ant-col-rtl ant-col-md-8">
                        <div className="option-item">
                            <div className="tag">
                                {option_0.value > 0 && (
                                    <Tag color="processing" closable onClose={() => unsetOption_0()}>
                                        {mapOption_0.get(option_0.value)}
                                    </Tag>
                                )}
                            </div>

                            <div className="title">
                                دامنه اختصاصی
                            </div>

                            <div className="price">
                                40
                                هزار تومان (ماهیانه)
                            </div>
                            <div className="tools">
                                <Popover
                                    content={content_0}
                                    title="دوره پرداخت"
                                    placement="bottom"
                                    trigger="click"
                                    visible={option_0.visible}
                                    onVisibleChange={() => handleOption_0(option_0)}
                                >
                                    <Button type="dashed">خرید بسته</Button>
                                </Popover>
                                <Button type="dashed">اطلاعات بیشتر</Button>
                            </div>
                        </div>
                    </div>

                    <div className="ant-col ant-col-xs-24 ant-col-rtl ant-col-md-8">
                        <div className="option-item">
                            <div className="tag">
                                {option_1.value > 0 && (
                                    <Tag color="processing" closable onClose={() => unsetOption_1()}>
                                        {mapOption_1.get(option_1.value)}
                                    </Tag>
                                )}
                            </div>
                            <div className="title">
                                شخصی‌سازی
                            </div>
                            <div className="price">
                                100
                                هزار تومان (ماهیانه)
                            </div>
                            <div className="tools">
                                <Popover
                                    content={content_1}
                                    title="دوره پرداخت"
                                    trigger="click"
                                    placement="bottom"
                                    visible={option_1.visible}
                                    onVisibleChange={() => handleOption_1(option_1)}
                                >
                                    <Button type="dashed">خرید بسته</Button>
                                </Popover>
                                <Button>اطلاعات بیشتر</Button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </Card>
    )
}

export default Option;